import { useEffect } from 'react';
import {
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type {
  GetPacksParams,
  PaginatedPacksResponse,
} from '../types';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

export function usePacks(
  filters?: GetPacksParams,
  options?: Omit<UseQueryOptions<PaginatedPacksResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const query = useQuery({
    queryKey: packKeys.list(filters),
    queryFn: ({ signal }) => packApi.list(filters, signal),
    staleTime: 60_000,
    ...(options as Omit<UseQueryOptions<PaginatedPacksResponse, Error>, 'queryKey' | 'queryFn'>),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: 'Erro ao buscar packs',
      description: query.error.message,
      variant: 'destructive',
    });
  }, [query.error]);

  return {
    packs: query.data?.data ?? [],
    totalPages: query.data?.totalPage ?? 1,
    totalItems: query.data?.totalItems ?? 0,
    currentPage: query.data?.page ?? filters?.page ?? 1,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
